/**
 * Score CRU do diagnóstico ESCALA é 0–100 (% do máximo teórico de pontos). A
 * metodologia diz que, mesmo gabaritando uma letra, SEMPRE sobra 10% pra
 * evoluir — então TODA exibição mapeia o cru pra teto de 90% (perfeito = 90,
 * nunca 100/115). Use `escalaPct` em qualquer lugar que mostre o score como %.
 */
export const ESCALA_DISPLAY_MAX = 90;

export const escalaPct = (raw: number): number =>
  Math.round((Math.min(Math.max(raw, 0), 100) / 100) * ESCALA_DISPLAY_MAX);
